import { render, staticRenderFns } from "./CertificiranPridelekPoCertifikatuPDF.vue?vue&type=template&id=0047d89e&scoped=true&"
import script from "./CertificiranPridelekPoCertifikatuPDF.vue?vue&type=script&lang=js&"
export * from "./CertificiranPridelekPoCertifikatuPDF.vue?vue&type=script&lang=js&"
import style0 from "./CertificiranPridelekPoCertifikatuPDF.vue?vue&type=style&index=0&id=0047d89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047d89e",
  null
  
)

export default component.exports